module.exports = __webpack_public_path__ + "img/PHP.7850e0bf.svg";